(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PresentList', PresentList);

    PresentList.$inject = ['$resource'];

    function PresentList ($resource) {
        var resourceUrl =  'api/present-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
